/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 *
 * Google CDN, Latest jQuery
 * To use the default WordPress version of jQuery, go to lib/config.php and
 * remove or comment out: add_theme_support('jquery-cdn');
 * ======================================================================== */

//For showing and hiding mobile menu
function toggleMobileMenu() {
    var mobileNav = jQuery('.mobile-nav');
    var navList = jQuery('.menu-holder');
    	if(mobileNav.hasClass('visible')) {
        	mobileNav.removeClass('visible').removeClass('background');
        	navList.removeClass('visible');
        	jQuery('body').removeClass('overflow-hidden');
        	jQuery('.icon-bar.top').removeClass('top-animate');
        jQuery('.icon-bar.middle').removeClass('middle-animate');
        jQuery('.icon-bar.bottom').removeClass('bottom-animate');
        if(jQuery('.banner').hasClass('is-visible')) {
            jQuery('.banner').removeClass('fixed-mobile-nav').addClass('is-fixed');
        }
    	} else {
        mobileNav.addClass('visible');
        jQuery('body').addClass('overflow-hidden');
        jQuery('.icon-bar.top').addClass('top-animate');
        jQuery('.icon-bar.middle').addClass('middle-animate');
        jQuery('.icon-bar.bottom').addClass('bottom-animate');
        if(jQuery('.banner').hasClass('is-visible')) {
            jQuery('.banner').addClass('fixed-mobile-nav').removeClass('is-fixed');
        }
        setTimeout(function() {
            mobileNav.addClass('background');
            navList.addClass('visible');
        }, 5);
    	}
}

function toggleHeader() {
    var currentTop = jQuery(window).scrollTop();
    //check if user is scrolling up
    if (currentTop < this.previousTop ) {
        	//if scrolling up...
        	if(currentTop <= 50) {
            	jQuery('.banner').removeClass('is-fixed').removeClass('is-visible');
        	} else {
            	jQuery('.banner').addClass('is-visible');
        	}
    } else {
        	//if scrolling down...
        	if(currentTop >= 80) {
            jQuery('.banner').removeClass('is-visible').addClass('is-fixed');
            jQuery( "li.dropdown" ).each(function( index ) {
              jQuery(this).removeClass('open');
            });
        }
    }
    //set previousTop for the next iteration
    this.previousTop = currentTop;
}

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        
        //For waypoint triggers
        $('.waypoint-trigger').click(function() {
            $('html, body').animate({
                scrollTop: $($(this).attr('target')).offset().top
            }, 500);
            return false;
        	});
        	
        	//For menu toggle on scroll
        	$(window).on('scroll', { previousTop: 0 }, function () {
            	if(!$('body').hasClass('overflow-hidden')) {
        	        toggleHeader();
        	    }
        	});
        	
        	//For showing the mobile menu
        	$('.navbar-toggle').click(function() {
            toggleMobileMenu();
        	});
        	
        	//For toggling toggle boxes
        	$('.vc_toggle').click(function(event){
            $('.vc_toggle').each(function(i, obj) {
                if($(this).hasClass('vc_toggle_active')) {
                    $(this).removeClass('vc_toggle_active');
                    $(this).find('.vc_toggle_content').hide(300);
                }
            });
            var self = this;
            setTimeout(function(){
                $('html, body').animate({
                    scrollTop: $($(self)).offset().top - 20
                }, 300);
                	jQuery('.banner').removeClass('is-fixed');
            }, 300);
        	});
        	
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        
        //Handle interactive circles
        $('.explanation.why').fadeIn('slow');
        $('.js-circle').click(function(event) {
            event.preventDefault();
            event.stopPropagation();
            
            $('.js-circle').each(function(index) {
                $(this).removeClass('active');
            });
            $('.explanation').each(function(index) {
                $(this).hide();
            });
            
            if($(this).hasClass('green')) {
                $('.explanation.why').fadeIn('slow');
            } else if($(this).hasClass('orange')) {
                $('.explanation.how').fadeIn('slow');
            } else if($(this).hasClass('blue')) {
                $('.explanation.what').fadeIn('slow');
            } else {
                $('.explanation.inspiration').fadeIn('slow');
            }
            
            $(this).addClass('active');
            
            if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
                $('html, body').animate({
                    scrollTop: $('.home-tip').offset().top
                }, 500);
            } else {
                $('html, body').animate({
                    scrollTop: $('.waypoint-target').offset().top
                }, 500);
            }
        });
        
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'page_template_template_head_dot': {
      init: function() {
        // JavaScript to be fired on the about us page
        $('.callout-home').append('<div class="callout-line"></div>');
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
